import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { AvisoResponseDTO, AvisoLeituraCliqueDTO, AvisoLeituraTempoDTO } from '../../models/dashboard/aviso.model';

@Injectable({ providedIn: 'root' })
export class AvisosService {

  constructor(private apiService: ApiService) {}

  buscarAtivos(): Observable<AvisoResponseDTO> {
    return this.apiService.read<AvisoResponseDTO>('/avisos/filtro-ativo-para-aviso?ativo=true');
  }

  registrarClique(avisoId: number): Observable<any> {
    const body: AvisoLeituraCliqueDTO = { avisoId };
    return this.apiService.create<any>('/avisoDeLeitura/adicionaClique', body);
  }

  registrarTempoVideo(avisoId: number, tempoSegundos: number): Observable<any> {
    const body: AvisoLeituraTempoDTO = { avisoId, tempoAssistidoEmSegundos: tempoSegundos };
    return this.apiService.create<any>('/avisoDeLeitura/atualizaTempoAssistido', body);
  }
}
